import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import worldMap from '../img/world-map-dark.png';

const Footer = () => {
  return React.createElement(
    'footer',
    { className: 'footer' },
    React.createElement(
      'div',
      { className: 'footer-content' },
      React.createElement(
        'div',
        { className: 'container' },
        React.createElement(
          'div',
          { className: 'footer-grid' },
          // Column 1 - About
          React.createElement(
            'div',
            { className: 'footer-col', style: { backgroundImage: `url(${worldMap})`, backgroundPosition: '50% 20px', backgroundRepeat: 'no-repeat' } },
            React.createElement('h4', null, 'About InfoNaukri'),
            React.createElement(
              'ul',
              { className: 'footer-list' },
              React.createElement(
                'li',
                null,
                React.createElement('i', { className: 'fas fa-map-marker-alt' }),
                ' A-21, 1st Floor A Block, Sector 58, Noida, Uttar Pradesh 201307'
              ),
              React.createElement(
                'li',
                null,
                React.createElement('i', { className: 'fas fa-envelope' }),
                ' ',
                React.createElement('a', { href: 'mailto:info@infonaukri.com' }, 'info@infonaukri.com')
              )
            ),
            React.createElement(
              'div',
              { className: 'footer-social' },
              React.createElement('a', { href: '#', 'aria-label': 'Facebook' }, React.createElement('i', { className: 'fab fa-facebook-f' })),
              React.createElement('a', { href: '#', 'aria-label': 'Twitter' }, React.createElement('i', { className: 'fab fa-twitter' })),
              React.createElement('a', { href: '#', 'aria-label': 'YouTube' }, React.createElement('i', { className: 'fab fa-youtube' })),
              React.createElement('a', { href: '#', 'aria-label': 'LinkedIn' }, React.createElement('i', { className: 'fab fa-linkedin-in' })),
              React.createElement('a', { href: '#', 'aria-label': 'Pinterest' }, React.createElement('i', { className: 'fab fa-pinterest-p' })),
              React.createElement('a', { href: '#', 'aria-label': 'Google Plus' }, React.createElement('i', { className: 'fab fa-google-plus-g' }))
            )
          ),
          // Column 2 - Quick Links
          React.createElement(
            'div',
            { className: 'footer-col' },
            React.createElement('h4', null, 'Quick Links'),
            React.createElement(
              'ul',
              { className: 'footer-list' },
              React.createElement('li', null, React.createElement(Link, { to: '/about' }, 'About Us')),
              React.createElement('li', null, React.createElement(Link, { to: '/terms' }, 'Terms & Conditions')),
              React.createElement('li', null, React.createElement(Link, { to: '/privacy' }, 'Privacy Policy')),
              React.createElement('li', null, React.createElement(Link, { to: '/disclaimer' }, 'Disclaimer')),
              React.createElement('li', null, React.createElement(Link, { to: '/refund' }, 'Cancellation & Refund'))
            )
          ),
          // Column 3 - About Us
          React.createElement(
            'div',
            { className: 'footer-col' },
            React.createElement('h4', null, 'About Us'),
            React.createElement(
              'p',
              { className: 'footer-about' },
              'InfoNaukri.com is the best E-Profile maker company and we provide best interview preparation team for crack the interview in the best company. InfoNaukri.com also provide social profile also for the client.'
            )
          ),
          // Column 4 - Jobs Listed
          React.createElement(
            'div',
            { className: 'footer-col' },
            React.createElement('h4', null, 'Jobs Listed'),
            React.createElement(
              'ul',
              { className: 'footer-list' },
              React.createElement('li', null, React.createElement('a', { href: '#' }, 'Jobs in Bangalore')),
              React.createElement('li', null, React.createElement('a', { href: '#' }, 'Jobs in Mumbai')),
              React.createElement('li', null, React.createElement('a', { href: '#' }, 'Jobs in Chennai')),
              React.createElement('li', null, React.createElement('a', { href: '#' }, 'Jobs in Delhi')),
              React.createElement('li', null, React.createElement('a', { href: '#' }, 'Jobs in Hyderabad'))
            )
          )
        )
      )
    ),
    // Copyright
    React.createElement(
      'div',
      { className: 'footer-bottom' },
      React.createElement(
        'div',
        { className: 'container' },
        React.createElement(
          'p',
          null,
          '\u00A9 2026 InfoNaukri.com - All Rights Reserved. ',
          React.createElement(Link, { to: '/' }, 'InfoNaukri')
        )
      )
    )
  );
};

export default Footer;